import FreeShip from '~/assets/icons/FreeShip';
import Secured from '~/assets/icons/SecuredIcon';
import Support from '~/assets/icons/SupportIcon';

export function WhyVapeStore() {
  const features = [
    {
      id: 1,
      icon: <FreeShip className="w-8 h-8 text-pink-500" />,
      title: 'Fast & Reliable Shipping',
      description:
        'We carefully pack and ship every order to ensure safe and timely delivery.',
    },
    {
      id: 2,
      icon: <Secured className="w-8 h-8 text-pink-500" />,
      title: 'Secure Payments',
      description:
        'Shop confidently with secure and trusted payment methods.',
    },
    {
      id: 3,
      icon: <Support className="w-8 h-8 text-pink-500" />,
      title: 'Dedicated Customer Support',
      description:
        'Our friendly support team is available to assist you before and after your purchase.',
    },
    {
      id: 4,
      icon: <Support className="w-8 h-8 text-pink-500" />,
      title: 'Premium Products',
      description:
        'Browse authentic vape devices, disposables, pods, e-liquids, and accessories from trusted brands.',
    },
  ];

  return (
    <section className="bg-white py-16 px-4 sm:px-6 lg:px-8">
      {/* Heading */}
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
          Why Choose KTM Vape
        </h2>
        <p className="mt-4 text-black text-lg font-normal">
          At KTM Vape, we&apos;re committed to providing premium vape products,
          trusted brands, competitive pricing, and reliable customer service.
          Whether you&apos;re new to vaping or an experienced user, we strive to
          deliver a seamless shopping experience.
        </p>
      </div>

      {/* Features */}
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-gray-200">
        {features.map((feature) => (
          <div
            key={feature.id}
            className="flex flex-col items-center text-center px-6 py-8"
          >
            {feature.icon}
            <h3 className="mt-4 text-lg font-semibold text-gray-900">
              {feature.title}
            </h3>
            <p className="mt-2 text-sm text-gray-600 text-start pl-4">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
